import type { OpenSearchStore } from "../types/products";

type TreezStoreContext = {
    storeId: string;
    mso_org_id?: string;
    mso_store_entity_id?: string;
};

function resolveOpenSearchStore(
    storeId: string | undefined | null,
    context: TreezStoreContext | undefined,
): OpenSearchStore | null {
    const key = String(storeId ?? "").trim();
    if (!key || !context) {
        return null;
    }

    const entityId = context.mso_store_entity_id;
    const orgId = context.mso_org_id;
    if (!entityId || !orgId) {
        return null;
    }

    return {
        short_name: context.storeId,
        mso_store_entity_id: entityId,
        mso_org_id: orgId,
    };
}

export { resolveOpenSearchStore };
